import React, { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Sidebar from "../Components/Sidebar/Sidebar";
import "./Dashboard.css";
import { FiUsers, FiCalendar } from "react-icons/fi";
import { BiUserCircle } from "react-icons/bi";
import { getUsersStats } from "../Api/auth";
import { Roller } from "react-awesome-spinners";
import DynamicTable from "../Components/DataTable/DynamicTable";
import { IoMailOpenOutline } from "react-icons/io5";

function Getduplidate() {


  const [loading, setLoading] = useState(false)
  const [duplicateemail, setDuplicateEmail] = useState([]);
  const [duplicatekeap, setDuplicateKeap] = useState([]);
  const [nonkeapuser, setNonKeapuser] = useState([]);
  const [nonstaxuser, setNonstaxUser] = useState([]);

  useEffect(() => {
    setLoading(true);
    getUsersStats().then((response) => {
      if (response.code === 200) {
        const apiResponse = response.data;
        setDuplicateEmail(apiResponse.data?.duplicate_emails);
        setDuplicateKeap(apiResponse.data?.duplicate_keap_ids);
        setNonKeapuser(apiResponse.data?.missing_keap_ids)
        setNonstaxUser(apiResponse.data?.missing_customer_ids)
      }
    }).catch((err) => {
      console.log("err", err);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  const [table, setTable] = useState('email');
  const [activeTable, setActiveTable] = useState('email');


  return (
    // <>
    <div>
      {
        loading ? (
          <div className="loading">
            <Roller />
          </div>
        ) : (
          <div>
            <div className="dashboard-container d-flex">
              <div className="sidebar-container">
                <Sidebar />
              </div>
              <div className="main-container">
                <div className="main-page-body-content">
                  <div className="main-page-body-content-body">
                    <div className="main-page-body-content-body-container">
                      <div className="row">
                        <div
                          className={`col-xl-3 col-lg-6 col-md-6 col-sm-12 ${activeTable === 'email' ? 'active' : ''}`}
                          onClick={() => { setTable('email'); setActiveTable('email'); }}
                          style={{
                            boxShadow: "0px 2px 4px #0000"
                          }}
                        >
                          <div className="card dashboard-card" style={{ border: "1px solid #d1d1d1", borderRadius: "20px", boxShadow: "0px 2px 4px #0000" }}>
                            <div className="card-body dashboard-card-body">
                              <div className="card-inner">
                                <div className="card-left-content">
                                  <p className="card-text">Duplicate Emails Counting</p>
                                  <h5 className="card-title">{duplicateemail.length}</h5>
                                </div>
                                <div className="card-right-content">
                                  <div className="card-icons">
                                    <div className="icon-box bg-yellow">
                                      <IoMailOpenOutline />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col-xl-3 col-lg-6 col-md-6 col-sm-12 ${activeTable === 'keapid' ? 'active' : ''}`}
                          onClick={() => { setTable('keapid'); setActiveTable('keapid'); }}
                        >
                          <div className="card dashboard-card" style={{ border: "1px solid #d1d1d1", borderRadius: "20px", boxShadow: "0px 2px 4px #0000" }}>
                            <div className="card-body dashboard-card-body">
                              <div className="card-inner">
                                <div className="card-left-content">
                                  <p className="card-text">Duplicate KeapID Counting</p>
                                  <h5 className="card-title">{duplicatekeap.length}</h5>
                                </div>
                                <div className="card-right-content">
                                  <div className="card-icons">
                                    <div className="icon-box bg-red">
                                      <FiUsers />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col-xl-3 col-lg-6 col-md-6 col-sm-12 ${activeTable === 'nonkeapid' ? 'active' : ''}`}
                          onClick={() => { setTable('nonkeapid'); setActiveTable('nonkeapid'); }}
                        >
                          <div className="card dashboard-card" style={{ border: "1px solid #d1d1d1", borderRadius: "20px", boxShadow: "0px 2px 4px #0000" }}>
                            <div className="card-body dashboard-card-body">
                              <div className="card-inner">
                                <div className="card-left-content">
                                  <p className="card-text">Non KeapId Users</p>
                                  <h5 className="card-title">{nonkeapuser.length}</h5>
                                </div>
                                <div className="card-right-content">
                                  <div className="card-icons">
                                    <div className="icon-box bg-green">
                                      <BiUserCircle />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col-xl-3 col-lg-6 col-md-6 col-sm-12 ${activeTable === 'nonstaxuser' ? 'active' : ''}`}
                          onClick={() => { setTable('nonstaxuser'); setActiveTable('nonstaxuser'); }}
                        >
                          <div className="card dashboard-card" style={{ border: "1px solid #d1d1d1", borderRadius: "20px", boxShadow: "0px 2px 4px #0000" }}>
                            <div className="card-body dashboard-card-body">
                              <div className="card-inner">
                                <div className="card-left-content">
                                  <p className="card-text">Non Stax Users</p>
                                  <h5 className="card-title">{nonstaxuser.length}</h5>
                                </div>
                                <div className="card-right-content">
                                  <div className="card-icons">
                                    <div className="icon-box bg-green">
                                      <BiUserCircle />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="main-page-body-content-body-container mt-4">
                        {
                          table === 'email' && (
                            <div>
                              <h3>Duplicate Emails</h3>
                              <DynamicTable data={duplicateemail} columns={[
                                { dataField: 'user_email', text: 'Email', sort: true },
                                { dataField: 'first_name', text: 'First name', sort: true },
                                { dataField: 'last_name', text: 'Last name', sort: true },
                                { dataField: 'phone', text: 'Phone', sort: true }
                              ]} keyField="email" />
                            </div>
                          )
                        }

                        {
                          table === 'keapid' && (
                            <div>
                              <h3>Duplicate Keap IDs</h3>
                              <DynamicTable data={duplicatekeap} columns={[
                                { dataField: 'user_email', text: 'Email', sort: true },
                                { dataField: 'first_name', text: 'First name', sort: true },
                                { dataField: 'last_name', text: 'Last name', sort: true },
                                { dataField: 'phone', text: 'Phone', sort: true },
                                { dataField: 'keap_id', text: 'Keap id', sort: true }
                              ]} keyField="keap_id" />
                            </div>
                          )
                        }

                        {
                          table === 'nonkeapid' && (
                            <div>
                              <h3>Non Keap ID Users</h3>
                              <DynamicTable data={nonkeapuser} columns={[
                                { dataField: 'user_email', text: 'Email', sort: true },
                                { dataField: 'first_name', text: 'First name', sort: true },
                                { dataField: 'last_name', text: 'Last name', sort: true },
                                { dataField: 'phone', text: 'Phone', sort: true },
                                { dataField: 'keap_id', text: 'Keap id', sort: true }
                              ]} keyField="user_id" />
                            </div>
                          )
                        }

                        {
                          table === 'nonstaxuser' && (
                            <div>
                              <h3>Non Stax Users</h3>
                              <DynamicTable data={nonstaxuser} columns={[
                                { dataField: 'user_email', text: 'Email', sort: true },
                                { dataField: 'first_name', text: 'First name', sort: true },
                                { dataField: 'last_name', text: 'Last name', sort: true },
                                { dataField: 'phone', text: 'Phone', sort: true },
                                { dataField: 'keap_id', text: 'Keap id', sort: true }
                              ]} keyField="user_id" />
                            </div>
                          )
                        }


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                .active .dashboard-card {
                  background-color:rgba(117, 179, 27, 0.32);
                  border: 2px solid #0288d1;
                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                }
              `}
            </style>
          </div>
        )}
    </div>

    // </>
  );
}

export default Getduplidate;